import React from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { debinStatusActions, statusTagColor } from "util/debin";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import useActionByDebinState from "pages/debinPayments/hooks/useActionByDebinState";
import InfoTag from "pages/debinPayments/_components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";

const EmitedebinItem = ({ emitededDebin, setDrawer, isDesktop }) => {
    const { options } = useActionByDebinState(debinStatusActions, emitededDebin, setDrawer);
    const debitAccountMask = emitededDebin?.buyer?.cbu ? `****${emitededDebin?.buyer?.cbu?.substring(17, 21)}` : "-";
    const message = () => {
        let messageText;
        if (emitededDebin?.status === "INACTIVA") {
            messageText = "PAUSADO";
        }
        if (emitededDebin?.status === "ACTIVA") {
            messageText = "ACTIVO";
        }
        if (emitededDebin?.status === "INACTIVA DEFINITIVA") {
            messageText = "ELIMINADO";
        }
        return messageText;
    };
    return (
        <>
            <GridTable.Data
                columnStart={1}
                rowStart={1}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.add.date"
                    titleTextType="I18N"
                    valueText={<FormattedDate showTime={false} date={emitededDebin.creationDate} />}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.seller"
                    titleTextType="I18N"
                    valueText={emitededDebin.seller.documentNumber}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 3 : 1}
                rowStart={isDesktop ? 1 : 3}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.service.label"
                    titleTextType="I18N"
                    valueText={emitededDebin.debin.lending}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 4 : 1}
                rowStart={isDesktop ? 1 : 4}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.dateExpitation"
                    titleTextType="I18N"
                    valueText={debitAccountMask}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 5 : 2} alignX="center" alignY={isDesktop ? "center" : "start"}>
                <InfoTag type="info" message={message()} tagBackground={statusTagColor(emitededDebin.status)} />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 6 : 3}
                rowStart={1}
                alignX="center"
                alignY={isDesktop ? "center" : "start"}>
                {options.length > 0 && (
                    <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
                )}
            </GridTable.Data>
        </>
    );
};

EmitedebinItem.propTypes = {
    emitededDebin: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
};

export default EmitedebinItem;
